import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top on every route change.
 * Fixes React Router's default behavior of preserving scroll offset when
 * navigating to a new page (e.g. clicking a link mid-way down the homepage
 * used to land you mid-way down the destination page too).
 *
 * Renders nothing; mount once inside <BrowserRouter> as a sibling of <Routes>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_path: pathname, page_location: window.location.href });
    }
  }, [pathname]);
  return null;
};

export default ScrollToTop;
